import {
    SurchargeTimeDefinition,
    useAllSurchargeTimeDefinitionsQuery,
    useDeleteSurchargeTimeDefinitionMutation
} from "../../../api/surcharge.slice.ts";
import {DataLoadingError} from "../../../components/DataLoadingError.tsx";
import {DataGrid} from "../../../components/DataGrid";
import {useSurchargeTimeDefinitionFormContext} from "./context.ts";
import {DataGridToolbar} from "../../../components/DataGrid/DataGridToolbar.tsx";
import {Button, ButtonToolbar} from "../../../components/Button.tsx";
import {useState} from "react";
import {useOpenConfirmDialog} from "../../../components/Dialog/GlobalConfirmDialogRenderer.tsx";

const columns = [
    {key: "surchargeGroup", label: "Surcharge Group", synthetic: true, render: (row: any) => row.surchargeGroup.name},
    {key: "name", label: "Name"},
    {key: "dayOfWeek", label: "Day Of Week",},
    {key: "startTime", label: "Start Time",},
    {key: "endTime", label: "End Time",},
]



export const SurchargeTimeDefinitionList = () => {
    const {data, isLoading, error} = useAllSurchargeTimeDefinitionsQuery()
    const {openDialog} = useSurchargeTimeDefinitionFormContext()

    const [deleteDefinition] = useDeleteSurchargeTimeDefinitionMutation()

    const [selectedRow, setSelectedRow] = useState<SurchargeTimeDefinition | undefined>();

    const openConfirm = useOpenConfirmDialog()

    return <>
        <DataGridToolbar>
            <ButtonToolbar>
                <Button onClick={() => openDialog()} disabled={!!selectedRow} size={"xs"} glyph={"plus"}>
                    Create
                </Button>
                <Button disabled={!selectedRow} size={"xs"} glyph={"pencil"}
                        onClick={() => openDialog(selectedRow?.id)}>
                    Edit
                </Button>
                <Button disabled={!selectedRow} size={"xs"} glyph={"trash"}
                        onClick={() => openConfirm({
                            title: "Delete", content: "Are you sure?", onConfirm: () => {
                                if (selectedRow) {
                                    deleteDefinition(selectedRow.id)
                                }

                            }
                        })}>
                    Delete
                </Button>
            </ButtonToolbar>

        </DataGridToolbar>
        <DataLoadingError isLoading={isLoading} error={error}>
            <DataGrid data={data || []}
                      onRowDoubleClick={(row) => openDialog(row.id)}
                      onSelect={row => setSelectedRow(row)}
                      columns={columns}

            />
        </DataLoadingError>
    </>
}